import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { View } from '../../../../shared/store/view/types';
import { CampaignModel } from '../../../../shared/store/campaign/types';
import { ActivatedRoute, Router } from '@angular/router';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../shared/store/view/views.service';
import { CampaignService } from '../../../../shared/store/campaign/campaign.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'app-campaign-details',
    templateUrl: './campaign-details.component.html',
    styleUrls: ['./campaign-details.component.scss'],
    standalone: false
})
export class CampaignDetailsComponent implements OnInit, OnDestroy {
  campaignId: number;
  campaignBase$: Observable<CampaignModel>;
  view$: Observable<View>;

  @Input() modalId: number;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly campaignService: CampaignService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService
  ) {
    this.campaignBase$ = this.campaignService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.campaignId = this.route.snapshot.params['id'];
    if (this.modalId) this.campaignId = this.modalId;

    this.campaignService.getById.call(this.campaignId.toString());

    this.campaignBase$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x)
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@campaignDetails', x.name);
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x)
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'campaignEdit') {
          this.router.navigate(['Crm/Campaigns/Edit/', this.campaignId]);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.campaignService.getById.reset();
    this.breadcrumbService.set('@campaignDetails', ' ');
  }
}
